export const validateAnswer = (answer) => {
  if (answer.required && ((Array.isArray(answer.value) && !answer.value.length) || answer.value === '')) {
    return false;
  }

  return true;
};
